import { render, staticRenderFns } from "./Academies.vue?vue&type=template&id=9558c6ba&"
import script from "./Academies.vue?vue&type=script&lang=js&"
export * from "./Academies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports